<template>
  <button
    class="shadow-lg inline-flex border-2 focus:outline-none select-none whitespace-nowrap"
    :class="[isLightMode() ? lightModeClasses : darkModeClasses, { 'cursor-not-allowed': disabled }]"
    :disabled="disabled"
    :style="`padding: ${padding_top}px ${padding_right}px ${padding_bottom}px ${padding_left}px; border-radius: ${border_radius}rem; font-weight: ${font_weight}; transition:background 0.25s;`"
    @keydown.enter.exact.prevent="click()"
  >
    <span class="material-icons my-auto px-1" :class="`${iconSize} ${iconColor}`">
      {{ icon }}
    </span>
    <div class="pr-2 my-auto" :class="`${textSize}`">
      {{ text }}
    </div>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    border_radius: {
      type: Number,
      default: 0.5
    },
    color_list: {
      type: Array,
      default: () => [
        'text-white',
        'border-primary-500',
        'bg-primary-500',
        'hover:border-primary-600',
        'hover:bg-primary-600',
        'disabled:bg-primary-100',
        'disabled:border-primary-100',
        'active:bg-primary-700',
        'active:border-primary-700'
      ]
    },
    dark_color_list: {
      type: Array,
      default: () => [
        'text-white',
        'border-primary-600',
        'bg-primary-600',
        'hover:border-primary-700',
        'hover:bg-primary-700',
        'disabled:bg-primary-800',
        'disabled:border-primary-800',
        'active:bg-primary-800',
        'active:border-primary-800'
      ]
    },
    font_weight: {
      type: String,
      default: '400'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    textSize: {
      type: String,
      default: ''
    },
    padding_top: {
      type: Number,
      default: 1
    },
    padding_bottom: {
      type: Number,
      default: 1
    },
    padding_left: {
      type: Number,
      default: 1
    },
    padding_right: {
      type: Number,
      default: 1
    }
  },
  setup(props, ctx) {
    const { isLightMode } = useConfigStatePresenter()

    const lightModeClasses = computed(() => props.color_list)

    const darkModeClasses = computed(() => props.dark_color_list)

    const click = () => {
      ctx.emit('click')
    }

    return { click, isLightMode, lightModeClasses, darkModeClasses }
  }
})
</script>

<style lang="postcss" scoped></style>
